<template>
  <nav class="navbar navbar-light bg-light im-navbar" @click="hideMenuGlobal">
    <router-link class="navbar-brand" to="/home" @click.stop.prevent="handleRedirectToDefault">
      <img :src="$img('imedia-logo.svg')" alt="Intermedia Logo" />
    </router-link>
    <template v-if="isBreadcrumbVisible">
      <div class="im-breadcrumb me-auto d-none d-lg-block">
        <ol class="breadcrumb">
          <li class="breadcrumb-item active" aria-current="page"></li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ $t(breadcrumbChunk1) }}
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ $t(breadcrumbChunk2) }}
          </li>
        </ol>
      </div>
    </template>
    <router-link
      to="/contact-us"
      class="btn btn-primary ms-auto me-3 d-none d-sm-block"
      @click.stop.prevent="handleGotoContactUs"
      >{{ $t("nav.contact") }}</router-link
    >
    <LanguageSwitcher class="me-3 d-none d-sm-flex" />
    <button class="navbar-toggler" type="button" @click.stop.prevent="showMenuGlobal">
      <span class="fas fa-bars"></span>
    </button>
  </nav>
</template>

<script>
  import { inject } from "vue";
  import LanguageSwitcher from "./LanguageSwitcher.vue";

  export default {
    name: "HeaderSection",
    components: {
      LanguageSwitcher,
    },
    setup() {
      // Inject menu controls from App.vue
      const showMenu = inject("showMenu");
      const hideMenu = inject("hideMenu");

      return {
        showMenu,
        hideMenu,
      };
    },
    data() {
      return {
        isBreadcrumbVisible: false,
        breadcrumbChunk1: "",
        breadcrumbChunk2: "",
      };
    },
    methods: {
      updateBreadcrumb(a, b) {
        this.breadcrumbChunk1 = a;
        this.breadcrumbChunk2 = b;
      },
      hideBreadcrumb() {
        this.isBreadcrumbVisible = false;
      },
      showBreadcrumb() {
        this.isBreadcrumbVisible = true;
      },
      // Menu control methods - now use injected functions directly
      hideMenuGlobal() {
        this.hideMenu();
      },
      showMenuGlobal() {
        this.showMenu();
      },
      handleRedirectToDefault() {
        // Call global method - use different name to avoid conflicts
        if (typeof this.redirectToDefault === "function") {
          this.redirectToDefault();
        }
      },
      handleGotoContactUs() {
        // Call global method - use different name to avoid conflicts
        if (typeof this.gotoContactUs === "function") {
          this.gotoContactUs();
        }
      },
    },
  };
</script>
